import type { ContextCharacteristic, ExtensionSchema } from '@/vantage/types/Extension.types';

export function addCharacteristicsForPurviewFields(
  extension: ExtensionSchema,
  purviewFields: string[],
): ExtensionSchema {
  const template = extension.contextCharacteristics?.[0];
  const existingKinds = extension.contextCharacteristics?.map((c) => c.kind) ?? [];
  const newPurviewFields: ContextCharacteristic[] =
    purviewFields
      ?.filter((field) => !existingKinds.includes(field))
      ?.map((field) => ({ ...template, kind: field, eventTimeRepresentation: undefined })) ?? [];

  return {
    ...extension,
    contextCharacteristics:
      newPurviewFields.length > 0
        ? extension.contextCharacteristics?.concat(newPurviewFields)
        : extension.contextCharacteristics,
  };
}
